import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { StepDetailsComponent } from ".";
import { Constants } from "../interfaces/constants";
import { ForwardComponent } from "./forward/forward.component";
import { ForwardByOwnerContainerComponent } from "./forward/owner/forwardByOwnerContainer.component";
import { NewStepComponent } from "./new-step/new-step.component";
import { WorkComponent } from "./work/work.component";
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: `step/:${Constants.routeParams.circId}`,
    children: [
      { path: "new", component: NewStepComponent },
      {
        path: `id/:${Constants.routeParams.stepId}`,
        children: [
          { path: "", pathMatch: "full", component: WorkComponent },
          { path: "forward", component: ForwardComponent },
          { path: "override", component: ForwardByOwnerContainerComponent },
          { path: "edit", component: StepDetailsComponent } // NOOO. Details is not edit, is it??
        ]
      }
    ],
    canActivate: [MsalGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StepsRoutingModule { }
